import React from 'react';
import { map } from 'lodash';

// import classnames from 'classnames';
// import searchQuery from 'query-string';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';

// import { entityInfoCellView as EntityInfoCellView } from 'ui/views/widgets/entityInfoCellView';
// import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
// import { overlay } from 'modules/overlay';
// import { textWithPatternMatch } from 'utils/textWithPatternMatch';


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { changeDefaultConfirm as ChangeDefaultConfirm } from 'ui/views/widgets/changeDefaultConfirm';
 *
 * // render
 * <ChangeDefaultConfirm propName='propValue'/>
 */
export const changeDefaultConfirm = ( props ) => {

    return (
        <div className='ui-change-default-confirm'>
			<div className='ui-change-default-confirm__header'>
				{ /* title for the modal */ }
				<div className='ui-change-default-confirm__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
            <div className='ui-change-default-confirm__body'>

                <div className='ui-change-default-confirm__body__description'>
                    <div className='ui-change-default-confirm__body__description__icon'>
                        <Icon name='warningBlue'/>
                    </div>
                    <div className='ui-change-default-confirm__body__description__value' dangerouslySetInnerHTML={ { __html: getLabel( props.description ) } } />
                </div>

                {/* button actions */}
				<div className='ui-change-default-confirm__body__actions'>
					{ map( props.actions, action => {
						return (
							<Button
								key={ action.name }
								{ ...action }
								outline={ 'cancel' === action.name ? true: false }
								size='large'
								className='ui-change-default-confirm__body__actions__action'
								onClick={ () => 'cancel' !== action.name ? props.onSumbitClick() : props.onCancelClick() }
							/>
						);
					} ) }
				</div>
            </div>
		</div>
    );
};

// set display name
changeDefaultConfirm.displayName = 'changeDefaultConfirm';

// set default props
changeDefaultConfirm.defaultProps = {};

// prop types
changeDefaultConfirm.propTypes = {};
